<template>
  <div class="advice">
    <TopContent />
    <div class="bottom">
      <div class="a-content" v-if="advice.length">
        <div class="a-item" v-for="(item, index) in advice" :key="index">
          <div class="a-title"
            >{{ item.title
            }}<span class="iconfont icon-warning-fill" v-if="item.danger"></span
          ></div>
          <div class="a-list">
            <div
              class="i-item"
              v-for="(item1, index1) in item.list"
              :key="index1"
            >
              <div class="i-title">{{ index1 + 1 }}、{{ item1.title }}</div>
              <div class="i-text" v-html="item1.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopContent from './top-content.vue'
export default {
  components: {
    TopContent
  },
  data() {
    return {}
  },
  computed: {
    advice() {
      let info = this.$store.state.cnaV2.resultData
      if (info) {
        let data = info.adviceList.advice
        let advice = []
        advice.push({
          title: '日常饮食',
          danger: false,
          list: data.dietList
        })
        advice.push({
          title: '补充维生素/矿物质',
          danger: false,
          list: data.vitaminList
        })
        advice.push({
          title: '减少摄入',
          danger: true,
          list: data.ingestionList
        })
        return advice
      }
      return []
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.advice {
  min-height: 100vh;
  background-color: #fff;

  .bottom {
    position: relative;
    z-index: 1;
    margin-top: -16px;
    padding: 20px;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    overflow: hidden;

    .a-content {
      padding: 20px 16px;
      background: rgba(244, 246, 250, 0.9);
      border-radius: 12px;

      .a-item {
        margin-bottom: 30px;

        .a-title {
          position: relative;
          padding-left: 10px;
          box-sizing: border-box;
          font-size: 18px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 21px;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          .iconfont {
            color: rgb(253, 97, 129);
            font-size: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .a-title::after {
          content: '';
          position: absolute;
          width: 4px;
          height: 17px;
          background: #66ccba;
          left: 0;
          top: 50%;
          transform: translate(0%, -50%);
        }

        .a-list {
          .i-item {
            font-size: 12px;
            font-family: PingFangSC-Medium, PingFang SC;
            line-height: 20px;
            margin-bottom: 16px;

            .i-title {
              font-size: 14px;
              color: rgba(0, 0, 0, 0.8);
              font-weight: 600;
            }

            .i-text {
              color: rgba(0, 0, 0, 0.5);
            }
          }

          .i-item:last-child {
            margin-bottom: 0;
          }
        }
      }

      .a-item:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
